import React from "react";
import { FiCheckCircle } from "react-icons/fi";
import { Modal } from "../Components/Modal";
import { modalManager } from "./ModalManager";

type SuccessModalOptions = {
	title?: string;
	message?: string;
	/** Shown under the message when present (e.g. "Deploy to preview to see changes live.") */
	note?: string;
	actionLabel?: string;
	onAction?: () => void;
	confirmLabel?: string;
	onClose?: () => void;
};

export const showSuccessModal = ({
	title = "Success",
	message = "Changes saved successfully.",
	note,
	actionLabel,
	onAction,
	confirmLabel = "Got it",
	onClose
}: SuccessModalOptions) => {
	modalManager.push(
		(controller) => (
			<>
				<Modal.Header closeButton>
					<Modal.Title>{title}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="flex items-start gap-3">
						<div className="rounded-full bg-emerald-100 p-2 text-emerald-600">
							<FiCheckCircle className="h-5 w-5" />
						</div>
						<div>
							<p className="text-sm text-slate-700">{message}</p>
							{note ? <p className="mt-1.5 text-sm font-medium text-amber-700">{note}</p> : null}
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					{actionLabel ? (
						<button
							type="button"
							className="inline-flex items-center rounded-full border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-700 shadow-sm transition hover:border-slate-300 hover:bg-slate-50"
							onClick={() => {
								modalManager.pop(controller.id);
								onAction?.();
							}}
						>
							{actionLabel}
						</button>
					) : null}
					<button
						type="button"
						className="inline-flex items-center rounded-full bg-emerald-600 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-emerald-500"
						onClick={() => modalManager.pop(controller.id)}
					>
						{confirmLabel}
					</button>
				</Modal.Footer>
			</>
		),
		{
			size: "sm",
			onClose
		}
	);
};


